import { render, staticRenderFns } from "./DuplicateProjectModal.vue?vue&type=template&id=34b986d9&"
import script from "./DuplicateProjectModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports